import { defineStore } from "pinia";
import IEcm from "../../types/Ecm/IEcm";
import { useApiBlocksStore } from "./apiBlocks";
import { i18n } from "@/init/i18n-setup";

export interface State {
  dataFeedsURL?: string;
  articleFeedsURL?: string;
  articlesURL?: string;
  showArticleBlock?: boolean;
}

export const useEcmStore = defineStore("ecm", {
  state: (): State => ({
    dataFeedsURL: undefined,
    articleFeedsURL: undefined,
    articlesURL: undefined,
    showArticleBlock: undefined,
  }),

  actions: {
    setEcm(ecm: IEcm) {
      this.dataFeedsURL = ecm.dataFeeds;
      this.articleFeedsURL = ecm.articleFeeds;
      this.articlesURL = ecm.articles;
      this.showArticleBlock = ecm.showArticleBlock;
      const apiBlocksStore = useApiBlocksStore();
      if (ecm.showArticleBlock) {
        apiBlocksStore.blocks.set("article", {
          name: i18n.global.t("blocks.article"),
          pluralName: i18n.global.t("blocks.articles"),
          icon: "article",
          itemsURL: ecm.articles,
          feedsURL: ecm.articleFeeds,
          apiWithoutSearch: true,
          nextKey: true,
          blockStructure: {
            image: {
              defaultValue:
                "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/pp1.png",
              label: i18n.global.t("article.parts.image"),
              width: 300,
              align: "center",
            },
            href: {
              defaultValue: "*|ARTICLE_HREF|*",
            },
            title: {
              defaultValue: `*|ARTICLE_TITLE|*`,
              label: i18n.global.t("article.parts.title"),
              "font-size": ["h2", "14px"],
              color: ["h2", "#000000"],
              "font-family": ["h2", "Helvetica, Arial, sans-serif"],
              "font-weight": ["h2", "normal"],
              "font-style": ["h2", "normal"],
              "text-transform": ["h2", "none"],
              "text-decoration": ["h2", "none"],
              padding: "5px 5px 5px 5px",
              align: "center",
            },
            description: {
              defaultValue: "*|ARTICLE_DESCRIPTION|*",
              label: i18n.global.t("article.parts.description"),
              padding: "5px 5px 5px 5px",
              "font-size": ["p", "13px"],
              color: ["p", "#000000"],
              "font-family": ["p", "Helvetica, Arial, sans-serif"],
              "font-weight": ["p", "normal"],
              "font-style": ["p", "normal"],
              "text-transform": ["p", "none"],
              "text-decoration": ["p", "none"],
              align: "center",
            },
            category: {
              defaultValue: `*|ARTICLE_CATEGORY|*`,
              label: i18n.global.t("article.parts.category"),
              "font-size": ["h3", "14px"],
              color: ["h3", "#000000"],
              "font-family": ["h3", "Helvetica, Arial, sans-serif"],
              "font-weight": ["h3", "normal"],
              "font-style": ["h3", "normal"],
              "text-transform": ["h3", "none"],
              "text-decoration": ["h3", "none"],
              padding: "5px 5px 5px 5px",
              align: "center",
            },
            "published-at": {
              defaultValue: `*|ARTICLE_PUBLISHED_AT|*`,
              label: i18n.global.t("article.parts.publishedat"),
              "font-size": ["h3", "14px"],
              color: ["h3", "#000000"],
              "font-family": ["h3", "Helvetica, Arial, sans-serif"],
              "font-weight": ["h3", "normal"],
              "font-style": ["h3", "normal"],
              "text-transform": ["h3", "none"],
              "text-decoration": ["h3", "none"],
              padding: "5px 5px 5px 5px",
              align: "center",
            },
            "published-by": {
              defaultValue: `*|ARTICLE_PUBLISHED_BY|*`,
              label: i18n.global.t("article.parts.publishedby"),
              "font-size": ["h3", "14px"],
              color: ["h3", "#000000"],
              "font-family": ["h3", "Helvetica, Arial, sans-serif"],
              "font-weight": ["h3", "normal"],
              "font-style": ["h3", "normal"],
              "text-transform": ["h3", "none"],
              "text-decoration": ["h3", "none"],
              padding: "5px 5px 5px 5px",
              align: "center",
            },
            button: {
              defaultValue: i18n.global.t("product.more"),
              label: i18n.global.t("article.parts.button"),
              align: "center",
              "background-color": ["mj-button", "#e85034"],
              color: ["mj-button", "#FFFFFF"],
              "font-size": ["mj-button", "13px"],
              "font-family": ["mj-button", "Helvetica, Arial, sans-serif"],
              "font-weight": ["mj-button", "normal"],
              "font-style": ["mj-button", "normal"],
              "text-transform": ["mj-button", "none"],
              "text-decoration": ["mj-button", "none"],
              padding: "5px 5px 5px 5px",
              "border-radius": ["mj-button", "3px"],
            },
            layout:
              "image:show,title:show,description:show,category:show,publishedat:show,publishedby:show,button:show",
          },
          apiStructure: {
            id: "id",
            value: "name",
            name: "name",
            title: "name",
            description: "description",
            href: "url",
            image: "imgurl",
            article_id: "id",
            category: "category",
            "published-at": "published_at",
            "published-by": "published_by",
            article_feed_id: "article_feed_id",
          },
        });
      }
    },
  },
});
